import { createSlice } from '@reduxjs/toolkit';

const dummyLorem = 'Lorem ipsum dolor sit amet, consectetur adipiscing aqua Title Lorem ipsum dolor sit amet, consectetur adipis';
const initialState = {
    id: 0,
    data: {
        bs: {
            desc:dummyLorem,
            name:'Sample Prize Name',
            pic:null,
        },
        dm: {
            type:'C',
            value:'Coupon Code',
            c:'Coupon Code',
            u:'https://perkzilla.com',
            o:dummyLorem
        },
        tt: {
            'type':'reward',
            'selected':'1',
            'value':'10', 
            'badge':'10 Referrals', 
            'deadline':null,
            'options':{
                'rewards': [
                    {
                        'label': 'Referrals',
                        'value': 1
                    },
                    {
                        'label': 'Shares',
                        'value': 2
                    },
                    {
                        'label': 'Visits',
                        'value': 3
                    },
                    {
                        'label': 'Points',
                        'value': 4
                    }
                ],
                'winners': [
                    {
                        'label': 'Winner Selected Randomly',
                        'value': 16
                    },
                    {
                        'label': 'Based On Leaderboard',
                        'value': 17
                    },
                    {
                        'label': 'Probability Based',
                        'value': 18
                    }
                ],
            },
        },
    }
};

const prizeSlice = createSlice({
    name: "pkzpc",
    initialState,
    reducers: {
        fillPrize(state, action) {
            state.data = action.payload;
        },
        updatePrizeID(state, action) {
            state.id = action.payload;
        },
        resetPriceState(state){
            state.id = 0;
            state.data = initialState.data;
        }, 
        updateTriggerType(state, action){
            state.data.tt.type = action.payload;
        }
    }
});

export const { fillPrize, updatePrizeID, resetPriceState, updateTriggerType } = prizeSlice.actions;
export default prizeSlice.reducer;